// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56ca73a6","453":"0703b9a8","732":"8aa3dcbb","977":"5e4ffb26"}[chunkId] + ".chunk.js";
};